<template>
  <transition name="sms-fade">
    <div
      class="sms_popup_mask"
      v-if="showSmsPopup"
    >
      <div class="sms_popup_panel" :class="{ sms_popup_panel_mobile: is_mobile }">
        <button type="button" class="sms_popup_close" aria-label="Cerrar" @click="closeSmsPopup">
          <span></span>
          <span></span>
        </button>
        <h2 class="sms_popup_title">Recibe actualizaciones por SMS</h2>
        <p class="sms_popup_subtitle">Ingresa tu número para recibir avisos relacionados con Pla Pla.</p>

        <label class="sms_popup_label" for="smsPhoneInput">Número de teléfono</label>
        <input
          id="smsPhoneInput"
          class="sms_popup_input"
          :class="{ sms_popup_input_error: !!smsPhoneError }"
          type="tel"
          inputmode="numeric"
          maxlength="14"
          placeholder="Por favor, ingrese su número de teléfono"
          v-model="smsPhone"
          @input="onSmsPhoneInput"
        />
        <p class="sms_popup_error" v-if="smsPhoneError">{{ smsPhoneError }}</p>
        <p class="sms_popup_hint">Usaremos este número únicamente para mensajes relacionados con tu cuenta, solicitud y servicio Pla Pla.</p>

        <p class="sms_popup_error sms_popup_agree_error" v-if="smsAgreeError">{{ smsAgreeError }}</p>
        <div class="sms_popup_consent">
          <div class="sms_popup_checkbox" :class="{ checked: smsAgreed }" @click="toggleSmsAgree">
            <svg v-if="smsAgreed" viewBox="0 0 12 10" width="12" height="10" aria-hidden="true">
              <path d="M1 5.2L4.2 8.5L11 1.5" stroke="#13151A" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <p class="sms_popup_consent_text" @click.stop="goSmsPrivacy">
            Acepto los
            <span class="sms_popup_link">SMS Terms and Conditions</span>
            y autorizo recibir mensajes SMS de Pla Pla.
          </p>
        </div>

        <button type="button" class="sms_popup_submit" @click="submitSmsPopup">Enviar</button>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import mobileOrpc from '@/mixins/index';

export default {
  name: 'SmsOptInPopup',
  mixins: [mobileOrpc],
  data() {
    return {
      smsPhone: '',
      smsAgreed: false,
      smsPhoneError: '',
      smsAgreeError: '',
    };
  },
  computed: {
    ...mapState(['showSmsPopup']),
  },
  watch: {
    showSmsPopup(val) {
      document.body.style.overflow = val ? 'hidden' : '';
      if (val) {
        this.smsPhone = '';
        this.smsAgreed = false;
        this.smsPhoneError = '';
        this.smsAgreeError = '';
      }
    },
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  },
  methods: {
    closeSmsPopup() {
      this.$store.commit('closeSmsPopup');
    },
    onSmsPhoneInput() {
      let digits = (this.smsPhone || '').replace(/\D/g, '').slice(0, 10);
      if (digits.length > 6) {
        this.smsPhone = digits.slice(0, 2) + ' ' + digits.slice(2, 6) + ' ' + digits.slice(6);
      } else if (digits.length > 2) {
        this.smsPhone = digits.slice(0, 2) + ' ' + digits.slice(2);
      } else {
        this.smsPhone = digits;
      }
      if (this.smsPhoneError) {
        this.smsPhoneError = '';
      }
    },
    toggleSmsAgree() {
      this.smsAgreed = !this.smsAgreed;
      if (this.smsAgreed) {
        this.smsAgreeError = '';
      }
    },
    goSmsPrivacy() {
      this.closeSmsPopup();
      this.$router.push({ path: '/smsprivacy' });
    },
    submitSmsPopup() {
      const phone = (this.smsPhone || '').replace(/\D/g, '');
      this.smsPhoneError = '';
      this.smsAgreeError = '';
      if (!phone) {
        this.smsPhoneError = 'Por favor, ingresa tu número de teléfono.';
        return;
      }
      if (phone.length !== 10) {
        this.smsPhoneError = 'Ingresa un número de teléfono válido de 10 dígitos.';
        return;
      }
      if (!this.smsAgreed) {
        this.smsAgreeError = 'Debes aceptar los SMS Terms and Conditions.';
        return;
      }
      this.$message({
        message: '¡Gracias! Te enviaremos actualizaciones por SMS.',
        type: 'success',
        customClass: 'sms_toast_message',
      });
      this.closeSmsPopup();
    },
  },
};
</script>

<style>
.sms-fade-enter-active,
.sms-fade-leave-active {
  transition: opacity 0.25s ease;
}
.sms-fade-enter-active .sms_popup_panel,
.sms-fade-leave-active .sms_popup_panel {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.sms-fade-enter,
.sms-fade-leave-to {
  opacity: 0;
}
.sms-fade-enter .sms_popup_panel,
.sms-fade-leave-to .sms_popup_panel {
  opacity: 0;
  transform: translateY(12px) scale(0.96);
}
.sms_popup_mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.62);
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
}
.sms_popup_panel {
  position: relative;
  width: 100%;
  max-width: 460px;
  box-sizing: border-box;
  padding: 36px 32px 28px;
  background: #1A1C22;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.45);
}
.sms_popup_panel_mobile {
  max-width: 100%;
  width: calc(100vw - 32px);
  padding: 28px 20px 22px;
  border-radius: 20px;
}
.sms_popup_close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #0A0B0E;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sms_popup_close span {
  position: absolute;
  width: 12px;
  height: 1.5px;
  background: #FFFFFF;
  border-radius: 1px;
}
.sms_popup_close span:first-child {
  transform: rotate(45deg);
}
.sms_popup_close span:last-child {
  transform: rotate(-45deg);
}
.sms_popup_title {
  margin: 0 36px 10px 0;
  font-size: 28px;
  line-height: 1.25;
  font-family: MiSans-Semibold, MiSans, PingFang SC, sans-serif;
  font-weight: 600;
  color: #FFFFFF;
}
.sms_popup_panel_mobile .sms_popup_title {
  font-size: 22px;
  margin-right: 28px;
}
.sms_popup_subtitle {
  margin: 0 0 28px;
  font-size: 15px;
  line-height: 1.5;
  font-family: MiSans-Regular, MiSans, PingFang SC, sans-serif;
  font-weight: 400;
  color: #8C8E94;
}
.sms_popup_panel_mobile .sms_popup_subtitle {
  font-size: 13px;
  margin-bottom: 22px;
}
.sms_popup_label {
  display: block;
  margin-bottom: 10px;
  font-size: 15px;
  line-height: 1.3;
  font-family: MiSans-Semibold, MiSans, PingFang SC, sans-serif;
  font-weight: 600;
  color: #FFFFFF;
}
.sms_popup_input {
  display: block;
  width: 100%;
  height: 52px;
  box-sizing: border-box;
  padding: 0 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  background: #13151A;
  outline: none;
  font-size: 16px;
  font-family: MiSans-Regular, MiSans, PingFang SC, sans-serif;
  color: #FFFFFF;
  transition: border-color 0.2s ease;
}
.sms_popup_input::placeholder {
  color: #5A5A63;
}
.sms_popup_input:focus {
  border-color: rgba(57, 202, 128, 0.55);
}
.sms_popup_input_error,
.sms_popup_input_error:focus {
  border-color: #E54D4D;
}
.sms_popup_error {
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 1.4;
  font-family: MiSans-Regular, MiSans, PingFang SC, sans-serif;
  color: #E54D4D;
}
.sms_popup_agree_error {
  margin: 0 0 8px;
}
.sms_popup_hint {
  margin: 12px 0 20px;
  font-size: 13px;
  line-height: 1.55;
  font-family: MiSans-Regular, MiSans, PingFang SC, sans-serif;
  color: #8C8E94;
}
.sms_popup_error + .sms_popup_hint {
  margin-top: 8px;
}
.sms_popup_consent {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-sizing: border-box;
  padding: 14px 14px;
  margin-bottom: 24px;
  border-radius: 12px;
  background: #24262E;
  cursor: pointer;
  user-select: none;
}
.sms_popup_checkbox {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 2px;
  box-sizing: border-box;
  border: 1.5px solid rgba(255, 255, 255, 0.55);
  border-radius: 3px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sms_popup_checkbox.checked {
  border-color: #39CA80;
  background: #39CA80;
}
.sms_popup_consent_text {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  font-family: MiSans-Regular, MiSans, PingFang SC, sans-serif;
  color: #B6B8BF;
  cursor: pointer;
}
.sms_popup_consent_text a,
.sms_popup_link {
  color: #39CA80;
  text-decoration: underline;
}
.sms_popup_submit {
  display: block;
  width: 100%;
  height: 52px;
  border: none;
  border-radius: 999px;
  background: #39CA80;
  color: #13151A;
  font-size: 17px;
  font-family: MiSans-Semibold, MiSans, PingFang SC, sans-serif;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.15s ease, background 0.15s ease;
}
.sms_popup_submit:hover {
  background: #45D68C;
}
.sms_popup_submit:active {
  transform: scale(0.98);
  opacity: 0.92;
}
.el-message.sms_toast_message {
  z-index: 10050 !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  box-sizing: border-box;
  width: auto;
  max-width: calc(100vw - 48px);
  min-width: 280px;
  padding: 14px 20px;
}
.el-message.sms_toast_message .el-message__content {
  line-height: 1.5;
  white-space: normal;
  word-break: break-word;
}
@media (max-width: 991px) {
  .el-message.sms_toast_message {
    width: calc(100vw - 48px);
    min-width: 0;
    padding: 16px 20px;
  }
  .sms_popup_panel:not(.sms_popup_panel_mobile) {
    max-width: 100%;
    width: calc(100vw - 32px);
    padding: 28px 20px 22px;
    border-radius: 20px;
  }
  .sms_popup_title {
    font-size: 22px;
  }
  .sms_popup_subtitle {
    font-size: 13px;
  }
}
</style>
